//#region src/transact_campus_card_host_system.ts
var TransactCampusCardHostSystem = /* @__PURE__ */ function(TransactCampusCardHostSystem) {
	TransactCampusCardHostSystem["TSE"] = "tse";
	TransactCampusCardHostSystem["IDX"] = "idx";
	return TransactCampusCardHostSystem;
}(TransactCampusCardHostSystem || {});
//#endregion
export { TransactCampusCardHostSystem };

//# sourceMappingURL=transact_campus_card_host_system.js.map